import { useEffect, useRef } from 'react'
import { watchApi } from './api'

/**
 * Tells the API which host this connection is watching, for the audience on /explore (docs/features/explore.md). An
 * event's hosts share one room, so nothing else says. The event's own page says nothing on a new connection, as saying
 * nothing means it: most viewers cost no request, however big the crowd. Moving to another host says so once, and so
 * does coming back. What it sets goes with the connection, so a new one says it again. A failed request leaves them
 * counted where they were; nobody's watching depends on it.
 */
export function useWatchingStage(stage: { id: string; kind?: string }, token: string | null, connected: boolean) {
  const said = useRef<string | null>(null)

  useEffect(() => {
    said.current = null
  }, [token])

  useEffect(() => {
    if (!connected) said.current = null
    if (!connected || !token || said.current === stage.id) return
    if (said.current === null && stage.kind === 'organization') return
    said.current = stage.id
    watchApi.watching(stage.id, token).catch(() => {})
  }, [stage.id, stage.kind, token, connected])
}
